import * as React from 'react';
import { Paper } from 'components/paper';
import { TextField } from 'components/input/TextField';
import { Button } from '@material-ui/core';
import { ContactUsController } from '../controller/ContactUsController';
import { FeedbackRpc } from 'rpc/FeedbackRpc';

export class FeedbackPaper extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);

        this.state = {currentMessage: ""};

        this.handleSendFeedbackClick = this.handleSendFeedbackClick.bind(this);
        this.handleMsgChange = this.handleMsgChange.bind(this);
    }

    private handleMsgChange(newValue: string) {
        this.setState({currentMessage: newValue});
    }

    private handleSendFeedbackClick() {
        var msg =this.state.currentMessage;
        if (msg == null) {
            return;
        }

        msg = msg.trim();

        if (msg.length < 1) {
            return;
        }

        FeedbackRpc.send(msg);

        this.setState({currentMessage: ""});
    }

    public render() {
        return (
            <Paper title="Send feedback" desc="Your feedback is very important for us. Leave a message if you miss a feature, found a bug or just want to tell us something.">
                <TextField multiline={true} label="Your message" value={this.state.currentMessage} onChange={this.handleMsgChange} ></TextField>

                <Button color="default" variant="contained" onClick={this.handleSendFeedbackClick}>Send</Button>
            </Paper>
        );
    }

}

export interface Props {

    controller: ContactUsController;

}

interface State {

    currentMessage: string;

}